import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CarsAvailabilitySelectors, CarSortOptionEnum } from "@apac/cars";
import {
  CarsAvailabilityActions,
  useCarsAvailabilityFilters,
  useFilterDialog as useCoreFilterDialog,
} from "@b2bportal/core-cars";

export const useFilterDialog = () => {
  const { context, handlers } = useCoreFilterDialog();
  const dispatch = useDispatch();

  const {
    context: { totalFilterCount },
  } = useCarsAvailabilityFilters();

  const selectedSort = useSelector(CarsAvailabilitySelectors.getSort);

  const [sortOption, setSortOption] = useState(selectedSort);

  const filtersChanged = useMemo(
    () => context.filtersChanged || sortOption !== selectedSort,
    [context.filtersChanged, sortOption, selectedSort]
  );

  const updateValuesToMatchState = useCallback(() => {
    handlers.updateValuesToMatchState();
    setSortOption(selectedSort);
  }, [handlers, selectedSort]);

  const resetAllFilters = useCallback(() => {
    handlers.resetAllFilters();
    dispatch(CarsAvailabilityActions.setSort(CarSortOptionEnum.Recommended));
  }, [dispatch, handlers]);

  const applyFilter = useCallback(() => {
    handlers.applyFilter();
    dispatch(CarsAvailabilityActions.setSort(sortOption));
  }, [dispatch, handlers, sortOption]);

  return {
    context: {
      ...context,
      totalFilterCount,
      filtersChanged,
      sortOption,
    },
    handlers: {
      ...handlers,
      updateValuesToMatchState,
      resetAllFilters,
      applyFilter,
      onSortChange: setSortOption,
    },
  };
};
